/**
 * jodit-config for jodit-vue@2.6.0
 */

import {uploadS3,uploadCsFile} from "@/api/cs/CsFileApi";
import {uploadAiclass, keygenAiclass} from "@/api/cs/CsFileApi";


const jodit_config = (function () {
    return { 
        // buttons: ['bold',{
        //     name: 'small',
        //     icon: '',
        //     tooltip: '작게',
        //     exec: (editor) => {
        //         var text = editor.s.html;
        //         if (!text) return;

        //         // calc editor selection offset length
        //         var sel = editor.s.sel;
        //         var selOffset = sel.anchorOffset;
        //         var selLength = sel.focusOffset-sel.anchorOffset;
        //         var node;
        //         for (node = sel.anchorNode; node && node !== sel.focusNode; node = node.nextSibling) {
        //             selLength += node.textContent.length;
        //         }
        //         for (node = sel.anchorNode; node && node !== editor.editor; node = node.parentNode) {
        //             while (node.previousSibling) {
        //                 node = node.previousSibling;
        //                 selOffset += node.textContent ? node.textContent.length : 0;
        //             }
        //         }
        //         // console.log('selOffset, selLength', selOffset, selLength);

        //         // main
        //         var hasCustomTag = false;
        //         var html = '';
        //         if (text.includes('<small>')) { // selection의 일부만 small일 때.
        //             html = text.replace('<small>','').replace('</small>','');
        //         } else if (editor.s.sel.baseNode.parentNode.tagName == 'SMALL') { // selection의 전부 small tag 내부일 때.
        //             html = '{/small}' + text + '{small/}'; // temporary custom tag
        //             hasCustomTag = true;
        //         } else {
        //             html = '<small>' + text + '</small>'
        //         }
        //         editor.s.remove();
        //         editor.s.insertHTML(html, true);

        //         var v = editor.value||'';
        //         if (hasCustomTag) {
        //             v = v.replace(/{\/small}/g, '<\/small>').replace(/{small\/}/g, '<small>');
        //         }
        //         v = v.replace(/<small><\/small>/g, '').replace(/<\/small><small>/g, '');
        //         editor.value = v;

        //         // generate editor new selection: offset length
        //         var anchorOffset = selLength < 0 ? selOffset+selLength : selOffset;
        //         var anchorLength = Math.abs(selLength);
        //         node = editor.editor;
        //         for (var i = 0; node && node.childNodes && i < node.childNodes.length; i++) {
        //             if (anchorOffset < node.childNodes[i].textContent.length) {
        //                 node = node.childNodes[i];
        //                 i = -1;
        //                 if (!node.childNodes || node.childNodes.length == 0) {
        //                     anchorLength = Math.min(anchorLength, node.textContent.length-anchorOffset);
        //                     break;
        //                 }
        //             } else {
        //                 anchorOffset -= node.childNodes[i].textContent.length;
        //             }
        //         }
        //         // console.log('anchorOffset, anchorLength', anchorOffset, anchorLength);
        //         var range = document.createRange()
        //         range.setStart(node, anchorOffset);
        //         range.setEnd(node, anchorOffset+anchorLength);
        //         range.collapse(selLength < 0); // false -> at end
        //         editor.s.selectRange(range);
        //     }}, 'source'],
        buttons: ['bold','italic','underline','strikethrough','eraser','|','ul','ol','indent','outdent','align',
                '|','font','fontsize','brush','paragraph','classSpan','lineHeight','superscript','subscript',
                '|','hr','image','file','table','link','symbols','|','undo','redo','source','fullsize'] ,
        config: {
        placeholder: '내용을 입력해주세요.',
        language: 'ko',
        showCharsCounter: false,
        showWordsCounter: false,
        showXPathInStatusbar: false,
        uploader: {
            enableDragAndDropFileToEditor: true,
            insertImageAsBase64URI: false,
            url: process.env.VUE_APP_ADM_API+'/api/cs/csFile/upload',
            baseurl: process.env.VUE_APP_ADM_API,
            uploader: {filesVariableName: 'filePath'},
            format: 'json',
            method: 'POST',
            pathVariableName: 'path',
            imageExtensions: ['jpg','jpeg','png','gif','bmp','ico'], // custom value
            maxFileSize: 50, // (MB) custom value, size of each file.
            isExtensionMatched: function (fileName, extensions) { // custom function
                if (!!fileName && extensions.indexOf(fileName.slice(fileName.lastIndexOf('.')+1).toLowerCase()) != -1) {
                    return true;
                }
                return false;
            },
            // upload 불가능한 파일만 제거한다.
            irregalFileFilter: function (formData) { // custom function
                let supportFile = undefined;
                let delKeys = [];
                let notSupportFile = [];
                for (let [key, value] of formData.entries()) {
                    if (key.startsWith('files')) { // 'files[0]', 'files[1]', ...
                        // maxFileSize check
                        // image extension check (now not check)
                        if (value.size > this.maxFileSize*1024*1024
                            // || !this.isExtensionMatched(value.name, this.imageExtensions)
                        ) {
                            notSupportFile.push(value.name);
                            delKeys.push(key);
                        } else if (!supportFile) {
                            supportFile = value;
                        }
                    }
                }
                delKeys.forEach(delKey => { formData.delete(delKey)});

                if (notSupportFile.length > 0) {
                    let alertStr = '업로드 불가능한 파일을 포함하고 있습니다.\n\n'+notSupportFile.join("\n")+'\n'
                                    // +'\n가능한 확장자: '+this.imageExtensions.join()
                                    +`\n개당 최대 ${this.maxFileSize}MB까지 가능합니다.`;
                    alert(alertStr);
                }
                return supportFile;
            },
            prepareData: function (formData) {
            // var file = formData.getAll('files[0]')[0]
            var file = this.options.irregalFileFilter(formData);
            var newFormData = new FormData();
            newFormData.append("mfile", file);
            newFormData.append("newFileName", "abcd");
            newFormData.append("floderDiv", "EMAIL"); // AwsS3Floder.java 
            console.log('uploadS3 formData:', ...newFormData);

            // uploadS3 api를 사용하기 위해 여기서 직접 호출한다.
            // 이후의 editor uploader process는 멈춰야 하는데, 방법이 없는거 같다. (403 error가 발생하지만 우선 감안하고 넘어간다)
            // 이후의 uploader 소스도 없으면 작동 안됨으로 그대로 남겨둔다.
            if (file) {
                (async function(sel, isImage) {
                    // for uploadAiclass test: 아래 주석 열고, newFileName / floderDiv param 막고, uploadS3 막고.
                // let result = await keygenAiclass({userId: 'laivdata_tc_001', userTypeCd: '105002'});
                // console.log('keygenAiclass result:', result);
                // newFormData.append("uploadKey", result.data);
                // console.log('uploadAiclass formData:', ...newFormData);
                // result = await uploadAiclass(newFormData);
                // console.log('uploadAiclass result:', result);

                let result = await uploadS3(newFormData);
                console.log('uploadS3 result:', result);

                if (isImage) {
                    sel.insertHTML(`<img src="${result.data.fullPath}" style="width: 300px;">`);
                } else {
                    sel.insertHTML(`<a href="${result.data.fullPath}">${result.data.orgName}</a>`);
                }
                }) (this.jodit.selection, this.options.isExtensionMatched(file.name, this.options.imageExtensions));
            }

            return newFormData;
            },
            isSuccess: function (resp) {
            // json타입으로 array 데이터를 리턴 받아서 처리할 때.
            // console.log('isSuccess: ', resp);
            return !resp.error;
            },
            getMessage: function (resp) {
            return '';
            },
            defaultHandlerSuccess: function() {
            },
            defaultHandlerError: function (resp) {
            // this.events.fire('errorPopap', [this.option.uploader.getMsg(resp)]);
            },
            error: function (e) {
            // console.log('uploader error', e);
            },
        },
        },
        plugins: [
            {
            name: 'event_handlers',
            callback: function (editor) {
                // editor.events.on('afterInit', function () {
                //   console.warn('Example plugin has beed initialized, check Jodit documentation for more details.')
                // });
                editor.events.on('change', function () {
                // console.log('change.');
                // jodit editor는 tag부분만 validator가 작동하고, view 부분은 작동이 안되서 수동으로 설정.
                let editor = $('#jodit_edit');
                var classValue = $(editor).attr('class');
                if (!!classValue && classValue.includes('is-invalid')) {
                    $(editor).prev().attr("data-v-eef1eb36" , true);
                    $(editor).prev().addClass('is-invalid');
                } else {
                    $(editor).prev().removeClass('is-invalid');
                }
                });
            }
            }
        ],
    };
})()

export {
    jodit_config,
}